/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */
import * as React from "react";
import { Row, Col } from "react-awesome-styled-grid";
import {
  Box,
  FlexContainer,
  Heading,
  MultipleSelect,
  SelectButton,
  theme,
} from "@nordcloud/gnui";
import { ReservationUtilizationTimePeriod } from "~/generated/graphql";
import { DefaultUtilizationChart } from "./DefaultUtilizationChart";

type Params = {
  nordcloudId: string;
};

const enum TIME_PERIOD {
  MONTH = 1,
  QUARTER = 3,
  YEAR = 12,
}

export function ReservedInstanceCharts({ nordcloudId }: Params) {
  const [currentTimePeriod, setCurrentTimePeriod] =
    React.useState<ReservationUtilizationTimePeriod>(
      ReservationUtilizationTimePeriod.ThreeMonths
    );
  function isActive(period: ReservationUtilizationTimePeriod) {
    return currentTimePeriod === period;
  }

  return (
    <Row>
      <Col xs={4} lg={12}>
        <Box spacing="spacing04" css={{ overflowX: "scroll", flex: 1 }}>
          <Heading level={4} marginBottom="spacing02">
            Total Utilisation
          </Heading>
          <Box
            px={theme.spacing.spacing03}
            py={theme.spacing.spacing02}
            spacing="spacing04"
          >
            <FlexContainer justifyContent="space-between">
              <MultipleSelect size="small">
                <SelectButton
                  name="month"
                  value={TIME_PERIOD.MONTH.toString()}
                  labelText="month"
                  data-testid="month"
                  style={{ width: "8rem" }}
                  isActive={isActive(ReservationUtilizationTimePeriod.OneMonth)}
                  onClick={() =>
                    setCurrentTimePeriod(
                      ReservationUtilizationTimePeriod.OneMonth
                    )
                  }
                />
                <SelectButton
                  name="quarter"
                  value={TIME_PERIOD.QUARTER.toString()}
                  labelText="3 months"
                  data-testid="quarter"
                  style={{ width: "8rem" }}
                  isActive={isActive(
                    ReservationUtilizationTimePeriod.ThreeMonths
                  )}
                  onClick={() =>
                    setCurrentTimePeriod(
                      ReservationUtilizationTimePeriod.ThreeMonths
                    )
                  }
                />
                <SelectButton
                  name="year"
                  value={TIME_PERIOD.YEAR.toString()}
                  labelText="12 months"
                  data-testid="year"
                  style={{ width: "8rem" }}
                  isActive={isActive(
                    ReservationUtilizationTimePeriod.TwelveMonths
                  )}
                  onClick={() =>
                    setCurrentTimePeriod(
                      ReservationUtilizationTimePeriod.TwelveMonths
                    )
                  }
                />
              </MultipleSelect>
            </FlexContainer>
          </Box>
          <DefaultUtilizationChart
            nid={nordcloudId}
            period={currentTimePeriod}
          />
        </Box>
      </Col>
    </Row>
  );
}
